export default "__VITE_ASSET__2uehQxtp__ 820w, __VITE_ASSET__dTGty5j___ 500w";